import { Location } from 'react-router-dom'

import { ORG_BILLING_ROUTE, ORG_ROUTE } from '@/shared/constants'
import { removeStar, replaceIdAndRemoveStar } from '@/shared/utils'

export function getOrgId(location: Location, orgId?: string) {
  if (!orgId) {
    const pathname = location.pathname
    return pathname.split('/')[2]
  } else {
    return orgId
  }
}

/**
 * pre-processed path string into billing nav route
 */
export function billingNavLink(path: string, location: Location, orgId?: string) {
  const ident = getOrgId(location, orgId)
  const finalPath = removeStar(path)
  const withSlash = finalPath ? `/${finalPath}` : ''
  return `${ORG_ROUTE}/${ident}/${ORG_BILLING_ROUTE}${withSlash}`
}

/**
 * Processing navigation route to this org page
 * use to provide <NavLink> `[to]` parameters
 *
 */
export function orgDetailNavLink(path: string, location: Location, orgId?: string) {
  const ident = getOrgId(location, orgId)
  const finalPath = replaceIdAndRemoveStar(path, ident)
  const withSlash = finalPath ? `/${finalPath}` : `/${ident}`
  return `${ORG_ROUTE}${withSlash}`
}
